<template>
  <div class="details__modal" ref="detailsModal" tabindex="0" @keydown.esc="close">
    <div class="details__modal__backdrop" @click="close"></div>
    <div class="details__modal__content">

      <div class="details__modal__content__header">
        <img :src="iconDeviceURL" alt="Ícone do dispositivo">
        <span>{{ contract.type }}</span>
      </div>

      <div class="details__modal__content__description">
        {{ contract.model }}
      </div>

      <div class="details__modal__content__table">
        <table>
          <thead>
            <tr>
              <th>Apólice {{ isPastDue ? 'VENCIDA' : 'VENCE' }} em:</th>
              <th>Apólice</th>
              <th>Número de série</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td :class="{ 'due': isPastDue }">{{ dueDate }}</td>
              <td>{{ contract.policyNumber }}</td>
              <td>{{ contract.serialNumber }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="details__modal__content__info">
        <img src="../../../assets/svg/alert.svg" alt="alert" />
        <h6>Para descobrir o IMEI do smartphone, digite no discador</h6>
        <h6 id="site-renewal__tel">*#06#</h6>
      </div>

      <div class="details__modal__content__buttons">
        <Button label="Renovar agora" theme="purple-filled" :disabled="!canRenew" @click="renew" />
        <Button label="Troquei de aparelho" theme="purple" @click="change" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/ui/Button'
import moment from 'moment'
moment.locale('pt-BR')

export default {
  name: 'DetailsModal',
  props: {
    contract: { type: Object, required: true }
  },
  components: {
    Button
  },
  created () {
    const body = document.getElementsByTagName('body')[0]
    body.setAttribute('aria-hidden', 'true')
  },
  mounted () {
    this.$refs.detailsModal.focus()
  },
  beforeDestroy () {
    const body = document.getElementsByTagName('body')[0]
    body.setAttribute('aria-hidden', 'false')
  },
  computed: {
    iconDeviceURL () {
      const type = this.contract.type.toLowerCase()
      const name = type === 'celular' ? 'cellphone' : type
      return require(`@/assets/svg/icon-device-${name}.svg`)
    },
    dueDate () {
      return moment(this.contract.expirationDate)
        .format('D [de] MMMM [de] YYYY')
        .toLowerCase()
    },
    isPastDue () {
      return moment() > moment(this.contract.expirationDate)
    },
    isWithinRenewalPeriod () {
      const today = moment()
      const dueDate = moment(this.contract.expirationDate)
      const diff = parseInt(dueDate.diff(today, 'days'))
      return diff >= 0 && diff <= 15
    },
    canRenew () {
      const today = moment()
      const dueDate = moment(this.contract.expirationDate)
      const diff = parseInt(dueDate.diff(today, 'days'))
      return diff <= 15
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    renew () {
      if (!this.isWithinRenewalPeriod) {
        this.$emit('renew')
        return
      }

      return this.$router.push({
        path: 'renovacao',
        query: { uuid: this.contract.uuid, promoCode: 'RENOVASITE' }
      })
    },
    change () {
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
.details__modal {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 999;

  &__backdrop {
    background: rgba(0, 0, 0, 0.4);
    height: 100%;
    position: absolute;
    width: 100%;
  }

  &__content {
    align-items: flex-start;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    max-width: 750px;
    padding: 40px;
    position: relative;
    width: 90%;

    &__header {
      align-items: center;
      display: flex;
      justify-content: flex-start;

      img {
        height: 22px;
        margin-right: 12px;
      }

      span {
        color: #707070;
        font-family: Rubik, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
      }
    }

    &__description {
      color: #444444;
      font-family: Oscine, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 25px;
      margin: 8px 0 40px;
    }

    &__table {
      background: #F8F9FC;
      border-radius: 8px;
      margin-bottom: 12px;
      padding: 16px;
      width: 100%;

      table {
        width: 100%;
        text-align: center;

        thead {
          color: #444444;
          font-family: Oscine, sans-serif;
          font-style: normal;
          font-weight: bold;
          font-size: 16px;
          line-height: 22px;
        }

        tbody {
          color: #707070;
          font-family: Rubik, sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
        }

        td {
          width: calc(100% / 3);

          &.due {
            color: #DF2E24;
          }
        }
      }
    }

    &__info {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      margin: 15px 0 20px 10px;

      h6 {
        margin-left: 10px;
        margin-right: 10px;
        height: 10px;

        &#site-renewal__tel {
          color: #6320e9;
          font-weight: bold;
          font-family: Rubik, sans-serif;
          margin-left: -5px;
        }
      }
    }

    &__buttons {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 40px;
      padding: 0 25%;
      width: 100%;

      ::v-deep button {
        width: 100%;

        + button {
          margin-top: 16px;
        }

        span {
          width: 100%;
        }
      }
    }
  }
}
</style>
